import React, { SyntheticEvent, useEffect, useMemo, useState } from "react";

import { ButtonProps, Icon } from "semantic-ui-react";

import { ADMIN_TAB_LIST } from "react-lib/apps/USER/CardSettingDivision";

import CardDivisionSpecialPermission from "./CardDivisionSpecialPermission";
import CardEmployeeDocument from "./CardEmployeeDocument";
import CardEmployeeInfoHistory from "./CardEmployeeInfoHistory";
import CardEmployeeInformation from "./CardEmployeeInformation";
import CardEmployeePaymentDetail from "./CardEmployeePaymentDetail";
import CardEmployeeProfileUX from "./CardEmployeeProfileUX";

import { PickedState } from "./HRMInterface";

type CardEmployeeProfileProps = Pick<PickedState, "adminMenuDivisions" | "selectedDivision"> & {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => void) => any;
  runSequence: any;
  DSPermissionSequence: any;
  EmployeeDocumentSequence: any;
  EmployeeHistorySequence: any;
  EmployeeInfoSequence: any;
  EmployeePaymentSequence: any;
  changePassword: any;
  employeeId?: number;
  hideTabs?: TabsNameType[];
  readOnly?: boolean;
  userId?: number;
  allDivisionGroup: any;
  buttonLoadCheck: any;
  django?: any;
  errorMessage: any;
  languageUX: string;
  masterData: any;
  masterOptions: any;
  selectedEmployee: any;
  successMessage: any;
  onGoBack?: () => void;
  config?: string;
};

type TabsType =
  | "DS_PERMISSION"
  | "EMPLOYEE_DOCUMENT"
  | "EMPLOYEE_HISTORY"
  | "EMPLOYEE_INFO"
  | "EMPLOYEE_PAYMENT";

export type TabsNameType = keyof typeof TAB_MENU_MAPPING;

const TAB_MENU_MAPPING = {
  // Employee Information
  [ADMIN_TAB_LIST["Employee Information"]]: "EMPLOYEE_INFO",
  // Employee Document
  [ADMIN_TAB_LIST["Employee Document"]]: "EMPLOYEE_DOCUMENT",
  // Division/Special permission
  [ADMIN_TAB_LIST["Division/Special permission"]]: "DS_PERMISSION",
  // Employee payment detail
  [ADMIN_TAB_LIST["Employee payment detail"]]: "EMPLOYEE_PAYMENT",
  // Employee info history
  [ADMIN_TAB_LIST["Employee info history"]]: "EMPLOYEE_HISTORY",
} as const;

const CardEmployeeProfile = (props: CardEmployeeProfileProps) => {
  const [tab, setTab] = useState<"" | TabsType>("");

  const filteredTabMenu = useMemo(() => {
    const tabs = props.adminMenuDivisions?.all["ข้อมูลบุคลากร"]?.tabs ?? [];
    const filtered = props.hideTabs
      ? Object.keys(TAB_MENU_MAPPING).filter(
          (menu) => !props.hideTabs?.includes(menu as TabsNameType)
        )
      : tabs;

    return Object.entries(TAB_MENU_MAPPING)
      .filter(([key]) => filtered.includes(key))
      .map((menu) => menu[1]);
  }, [props.adminMenuDivisions, props.hideTabs]);

  useEffect(
    () => () => {
      props.setProp("selectedEmployee", null);
    },
    []
  );

  useEffect(() => {
    setTab(filteredTabMenu[0] || "");
  }, [filteredTabMenu]);

  const handleChangeTab = (e: SyntheticEvent, data: ButtonProps) => {
    setTab(data.name);
  };

  return (
    <div>
      <CardEmployeeProfileUX
        filteredTabMenu={filteredTabMenu}
        tab={tab}
        selectedEmployee={props.selectedEmployee}
        onChangeTab={handleChangeTab}
        buttonBack={
          props.onGoBack && (
            <div style={{ display: "flex" }} onClick={props.onGoBack}>
              <Icon color="blue" name="arrow alternate circle left" />
              <label style={{ cursor: "pointer" }}>BACK</label>
            </div>
          )
        }
      />

      {tab === "EMPLOYEE_INFO" && (
        <CardEmployeeInformation
          onEvent={props.onEvent}
          setProp={props.setProp}
          runSequence={props.runSequence}
          EmployeeInfoSequence={props.EmployeeInfoSequence}
          changePassword={props.changePassword}
          employeeId={props.selectedEmployee?.id ?? props.employeeId}
          readOnly={props.readOnly}
          userId={props.selectedEmployee?.user_employee?.[0]?.id ?? props.userId}
          allDivisionGroup={props.allDivisionGroup}
          buttonLoadCheck={props.buttonLoadCheck}
          django={props.django}
          errorMessage={props.errorMessage}
          languageUX={props.languageUX}
          masterData={props.masterData}
          masterOptions={props.masterOptions}
          successMessage={props.successMessage}
        />
      )}

      {tab === "EMPLOYEE_DOCUMENT" && (
        <CardEmployeeDocument
          setProp={props.setProp}
          runSequence={props.runSequence}
          EmployeeDocumentSequence={props.EmployeeDocumentSequence}
          readOnly={props.readOnly}
          buttonLoadCheck={props.buttonLoadCheck}
          config={props.config}
        />
      )}

      {tab === "DS_PERMISSION" && (
        <CardDivisionSpecialPermission
          setProp={props.setProp}
          runSequence={props.runSequence}
          DSPermissionSequence={props.DSPermissionSequence}
          readOnly={props.readOnly}
          allDivisionGroup={props.allDivisionGroup}
          buttonLoadCheck={props.buttonLoadCheck}
          masterOptions={props.masterOptions}
          selectedEmployee={props.selectedEmployee}
        />
      )}

      {tab === "EMPLOYEE_PAYMENT" && (
        <CardEmployeePaymentDetail
          setProp={props.setProp}
          runSequence={props.runSequence}
          EmployeePaymentSequence={props.EmployeePaymentSequence}
          readOnly={props.readOnly}
          buttonLoadCheck={props.buttonLoadCheck}
          errorMessage={props.errorMessage}
          languageUX={props.languageUX}
          masterData={props.masterData}
          masterOptions={props.masterOptions}
          selectedEmployee={props.selectedEmployee}
        />
      )}

      {tab === "EMPLOYEE_HISTORY" && (
        <CardEmployeeInfoHistory
          runSequence={props.runSequence}
          EmployeeHistorySequence={props.EmployeeHistorySequence}
          buttonLoadCheck={props.buttonLoadCheck}
          masterOptions={props.masterOptions}
          config={props.config}
        />
      )}
    </div>
  );
};

CardEmployeeProfile.displayName = "CardEmployeeProfile";

export default React.memo(CardEmployeeProfile);
